
<mat-card *ngIf="showBanner()">
  iOS Banner PWA
</mat-card>